export default __webpack_public_path__ + "static/Fintech-casestudy-app-daf81a1396ada28eb19491d6f0e6e130.webp";